/**
 * @generated SignedSource<<6759a940eda62a7806d461ed0a961ce6>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum ContentPermissionType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList_nodes_SubjectUserOrGroup_group_GroupWithRestrictions =
  {
    __typename?: "GroupWithRestrictions";
    id: string | null;
    name: string | null;
    permissionType: SitePermissionType | null;
  };
export type AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList_nodes_SubjectUserOrGroup_user_UserWithRestrictions_profilePicture_Icon =
  {
    __typename?: "Icon";
    width: number | null;
    height: number | null;
    isDefault: boolean | null;
    path: string;
  };
export type AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList_nodes_SubjectUserOrGroup_user_UserWithRestrictions =
  {
    __typename?: "UserWithRestrictions";
    accountId: string | null;
    displayName: string | null;
    email: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList_nodes_SubjectUserOrGroup_user_UserWithRestrictions_profilePicture_Icon | null;
  };
export type AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList_nodes_SubjectUserOrGroup =
  {
    __typename?: "SubjectUserOrGroup";
    id: string | null;
    permissions: Array<ContentPermissionType | null>;
    type: string | null;
    displayName: string | null;
    group: AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList_nodes_SubjectUserOrGroup_group_GroupWithRestrictions | null;
    user: AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList_nodes_SubjectUserOrGroup_user_UserWithRestrictions | null;
  };
export type AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    hasNextPage: boolean | null;
    endCursor: string | null;
  };
export type AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList =
  {
    __typename?: "PaginatedSubjectUserOrGroupList";
    groupCount: number;
    userCount: number;
    nodes: Array<AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList_nodes_SubjectUserOrGroup | null> | null;
    pageInfo: AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList_pageInfo_PageInfo | null;
  };
export type AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions =
  {
    __typename?: "ContentPermissions";
    subjectsWithEffectiveContentPermissions: AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions_subjectsWithEffectiveContentPermissions_PaginatedSubjectUserOrGroupList;
  };
export type AccessDetailsDialogContentAccessDetailsQuery_singleContent_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase =
  {
    __typename?: "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
    webui: string | null;
  };
export type AccessDetailsDialogContentAccessDetailsQuery_singleContent_Content =
  {
    __typename?: "Content";
    id: string | null;
    title: string | null;
    type: string | null;
    links: AccessDetailsDialogContentAccessDetailsQuery_singleContent_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase | null;
  };
export type AccessDetailsDialogContentAccessDetailsQuery_Query = {
  __typename?: "Query";
  contentPermissions: AccessDetailsDialogContentAccessDetailsQuery_contentPermissions_ContentPermissions | null;
  singleContent: AccessDetailsDialogContentAccessDetailsQuery_singleContent_Content | null;
};
export type AccessDetailsDialogContentAccessDetailsQueryVariables = Exact<{
  contentId: Scalars["ID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  filterText?: InputMaybe<Scalars["String"]["input"]>;
}>;
export type AccessDetailsDialogContentAccessDetailsQuery =
  AccessDetailsDialogContentAccessDetailsQuery_Query;
